import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiRequest from "../../api/request";
import { Search } from "@mui/icons-material";

const initialState = {
  srtCountData: {},
  srtdetaildata: [],
  tutorReplacedData: [],
  replaceddetaildata: [],
  studentdata: [],
  crmlist: [],
  tutordata: [],
  tastudentdata: [],
  trleaddata: [],
  crmlisttr: [],
  trdetailedTaview: [],
  crolistundercrm: [],
  loading: false,
  innerLoading: false,
};

export const getRescheduledcounts = createAsyncThunk(
  "srt/getrescheduledcount",
  async ({ userId, fromDate, toDate }) => {
    const res = await apiRequest({
      method: "get",
      url: `session-basic-counts?userId=${userId}&fromDate=${fromDate}&toDate=${toDate}`,
    });

    return res;
  }
);
export const getDetailwiseData = createAsyncThunk(
  "srt/getdetailwise",
  async ({ projectId, userId, crmId, page, limit, fromDate, toDate }) => {
    const res = await apiRequest({
      method: "get",
      url: `session-basic-counts/cro-based-counts?project_id=${projectId}&fromDate=${fromDate}&toDate=${toDate}&userId=${userId}&crmId=${crmId}&page=${page}&limit=${limit}`,
    });

    return res;
  }
);
export const getStudentData = createAsyncThunk(
  "srt/getstudentdata",
  async ({ projectId, croId, page, limit, fromDate, toDate }) => {
    const res = await apiRequest({
      method: "get",
      url: `session-basic-counts/cro-based-leads?croId=${croId}&fromDate=${fromDate}&toDate=${toDate}&project_id=${projectId}&page=${page}&limit=${limit}`,
    });

    return res;
  }
);
export const getCRMlist = createAsyncThunk(
  "srt/getcrmlist",
  async ({ projectId }) => {
    const res = await apiRequest({
      method: "get",
      url: `session-basic-counts/get-crm-list?projectId=${projectId}`,
    });

    return res;
  }
);
// ------------------------------------tacrmlist---------------------------------
export const getTrcrmlist = createAsyncThunk(
  "srt/getTrcrmlist",
  async (projectId) => {
    const res = await apiRequest({
      method: "get",
      url: `analytics/all-crm/${projectId}`,
    });

    return res;
  }
);

export const getTaTutorData = createAsyncThunk(
  "srt/gettutordata",
  async ({ projectId, fromDate, toDate, page, limit }) => {
    const res = await apiRequest({
      method: "get",
      url: `session-basic-counts/tutor-based-counts?project_id=${projectId}&fromDate=${fromDate}&toDate=${toDate}&page=${page}&limit=${limit}`,
    });

    return res;
  }
);
export const getStudentdataTa = createAsyncThunk(
  "srt/getstudentdatata",
  async ({ projectId, fromDate, toDate, page, limit, trainer_id }) => {
    const res = await apiRequest({
      method: "get",
      url: `session-basic-counts/tutor-based-leads?project_id=${projectId}&fromDate=${fromDate}&toDate=${toDate}&page=${page}&limit=${limit}&trainer_id=${trainer_id}`,
    });

    return res;
  }
);
// -----------------------------------trt---------------------------------

export const getTutoReplacedData = createAsyncThunk(
  "srt/gettutorreplaceddata",
  async ({ fromDate, toDate }) => {
    const res = await apiRequest({
      method: "get",
      url: `analytics/tutorReplacementStats/project?from=${fromDate}&to=${toDate}`,
    });

    return res;
  }
);

export const getReplacedDetailedView = createAsyncThunk(
  "srt/gettutorreplaceddetailview",
  async (data) => {
    const res = await apiRequest({
      method: "get",
      url: `analytics/tutorReplacementStats/cro/${data.projectId}?page=${data.page}&limit=${data.limit}&from=${data.fromDate}&to=${data.toDate}&crmId=${data.crmId}&croId=${data.croId}`,
    });

    return res;
  }
);

export const getTrLeadData = createAsyncThunk(
  "srt/gettrleaddata",
  async ({
    croId,
    trainerId,
    fromDate,
    toDate,
    page,
    limit,
    search,
    projectId,
  }) => {
    // Determine which ID to use
    const idParam = croId
      ? `croId=${croId}`
      : trainerId
      ? `trainerId=${trainerId}`
      : "";

    const res = await apiRequest({
      method: "get",
      url: `analytics/tutorReplacementStats/leads/?${idParam}&from=${fromDate}&to=${toDate}&page=${page}&limit=${limit}&search=${search}&projectId=${projectId}`,
    });

    return res;
  }
);

export const getReplacedDetailedTaView = createAsyncThunk(
  "srt/gettutorreplaceddetailTaview",
  async (data) => {
    const res = await apiRequest({
      method: "get",
      url: `analytics/tutorReplacementStats/tutor/${data.projectId}?page=${data.page}&limit=${data.limit}&from=${data.fromDate}&to=${data.toDate}`,
    });

    return res;
  }
);

export const getCrolistunderCrm = createAsyncThunk(
  "srt/getCrolistunderCrm",
  async (crmdata) => {
    const res = await apiRequest({
      method: "get",
      url: `users/all-users-under/${crmdata.crmId}?isAll=true`,
    });

    return res;
  }
);

const srtSlice = createSlice({
  name: "srt",
  initialState,

  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getRescheduledcounts.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getRescheduledcounts.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        srtCountData: action.payload.data,
      };
    });
    builder.addCase(getDetailwiseData.pending, (state) => {
      return {
        ...state,
        innerLoading: true,
      };
    });
    builder.addCase(getDetailwiseData.fulfilled, (state, action) => {
      return {
        ...state,
        innerLoading: false,
        srtdetaildata: action.payload,
      };
    });
    builder.addCase(getTutoReplacedData.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getTutoReplacedData.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        tutorReplacedData: action.payload.data,
      };
    });
    builder.addCase(getReplacedDetailedView.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getReplacedDetailedView.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        replaceddetaildata: action.payload,
      };
    });
    builder.addCase(getStudentData.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getStudentData.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        studentdata: action.payload.data,
      };
    });
    builder.addCase(getCRMlist.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getCRMlist.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        crmlist: action.payload.data,
      };
    });
    builder.addCase(getTrcrmlist.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getTrcrmlist.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        crmlisttr: action.payload.data,
      };
    });
    builder.addCase(getTaTutorData.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getTaTutorData.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        tutordata: action.payload,
      };
    });
    builder.addCase(getStudentdataTa.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getStudentdataTa.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        tastudentdata: action.payload,
      };
    });
    builder.addCase(getTrLeadData.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getTrLeadData.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        trleaddata: action.payload,
      };
    });
    builder.addCase(getReplacedDetailedTaView.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getReplacedDetailedTaView.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        trdetailedTaview: action.payload,
      };
    });
    builder.addCase(getCrolistunderCrm.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getCrolistunderCrm.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        crolistundercrm: action.payload.data,
      };
    });
  },
});

// export const { apiCallData, admissionReg, storeId } = smoSlice.actions;

export default srtSlice.reducer;
